var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-symbol"},[_c('svg',[_c('g',[_c('use',{attrs:{"xlink:href":_vm.use}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }